import { render, staticRenderFns } from "./kyc-chart.vue?vue&type=template&id=ae94b884&"
import script from "./kyc-chart.vue?vue&type=script&lang=js&"
export * from "./kyc-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports